import { render, staticRenderFns } from "./WarningDialogComponent.vue?vue&type=template&id=28bfafa3&"
import script from "./WarningDialogComponent.vue?vue&type=script&lang=js&"
export * from "./WarningDialogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports